import script from "./EmailSentTableModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailSentTableModal.vue?vue&type=script&setup=true&lang=js"

import "./EmailSentTableModal.vue?vue&type=style&index=0&id=32034023&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32034023"]])

export default __exports__